import { LOCALES } from 'i18n/locales';

export const dateInputIntl = {
    [LOCALES.ENGLISH]: {
        'DateInput.Day': 'Day',
        'DateInput.Month': 'Month',
        'DateInput.Year': 'Year',
        'DateInput.InvalidDateMessage': 'Enter a valid {0}'
    },
    [LOCALES.WELSH]: {
        'DateInput.Day': 'Diwrnod',
        'DateInput.Month': 'Mis',
        'DateInput.Year': 'Blwyddyn',
        'DateInput.InvalidDateMessage': 'Cofnodwch {0} dilys'
    }
};
